export default "__VITE_ASSET__C4YDSz2i__"